{
  "bio": "Building the layer between human intent and useful software: AI agents, local-first tools, and developer workflows. Sometimes shipping tomorrow by accident.",
  "name": "Pengusto",
  "streak": {
    "current": 21,
    "longest": 21,
    "totalDays": 161
  },
  "company": "Kikaio",
  "gitskins": {
    "goal": "get-hired",
    "tone": "premium",
    "content": {
      "cta": "Discuss an opportunity",
      "role": "C# and HTML developer",
      "skills": [
        "C#",
        "HTML",
        "JavaScript",
        "TeX",
        "Python",
        "CSS",
        "TypeScript",
        "Kotlin"
      ],
      "longBio": "Building the layer between human intent and useful software: AI agents, local-first tools, and developer workflows. Sometimes shipping tomorrow by accident. Based in Germany. Currently connected with Kikaio.",
      "headline": "Pengusto builds thoughtful software for real-world problems.",
      "projects": [
        {
          "url": "https://github.com/pengusto/penguin-patches",
          "forks": 0,
          "stars": 2,
          "title": "penguin-patches",
          "summary": "Focused Android app patches compatible with Morphe. Current catalogue: Fossify Calendar, Messages, File Manager, Contacts and Music Player. Pre-release.",
          "language": "Kotlin",
          "repoName": "penguin-patches"
        },
        {
          "url": "https://github.com/pengusto/let-him-grill",
          "forks": 0,
          "stars": 1,
          "title": "let-him-grill",
          "summary": "A Codex planning skill: resolve reversible decisions, stop at human gates, and resume the decision path.",
          "language": "Python",
          "repoName": "let-him-grill"
        },
        {
          "url": "https://github.com/pengusto/kaplum-studio",
          "forks": 0,
          "stars": 0,
          "title": "kaplum-studio",
          "summary": "Learn JavaScript by drawing: a visual Turtle studio with editable examples, guided experiments, code stepping and offline project export.",
          "language": "JavaScript",
          "repoName": "kaplum-studio"
        },
        {
          "url": "https://github.com/pengusto/push-my-tabs",
          "forks": 0,
          "stars": 0,
          "title": "push-my-tabs",
          "summary": "Layout-aware keyboard shortcuts and quick tab actions for Chrome and Firefox. Switch and move horizontal or vertical tabs.",
          "language": "JavaScript",
          "repoName": "push-my-tabs"
        },
        {
          "url": "https://github.com/pengusto/cookbook",
          "forks": 0,
          "stars": 0,
          "title": "cookbook",
          "summary": "Focused agent workflows for Codex and Claude Code. One shared source, Plain or Kitchen names. Experimental Beta.",
          "language": "HTML",
          "repoName": "cookbook"
        },
        {
          "url": "https://github.com/pengusto/you-got-this",
          "forks": 0,
          "stars": 0,
          "title": "you-got-this",
          "summary": "Autonomous project-execution skill for Codex and compatible agent harnesses.",
          "language": "Python",
          "repoName": "you-got-this"
        },
        {
          "url": "https://github.com/pengusto/spark-hedge-physics-2-community",
          "forks": 0,
          "stars": 1,
          "title": "spark-hedge-physics-2-community",
          "summary": "Independent Spark / Hedge Physics 2 community mirror: minimal Unity capsule demo, WASD controls, and attributed upstream source reference.",
          "language": "C#",
          "repoName": "spark-hedge-physics-2-community"
        },
        {
          "url": "https://github.com/pengusto/google-classroom-mcp",
          "forks": 0,
          "stars": 1,
          "title": "google-classroom-mcp",
          "summary": "Local Google Classroom MCP for teachers: validated tools, scheduled drafts, file attachments and paginated course access.",
          "language": "TypeScript",
          "repoName": "google-classroom-mcp"
        }
      ],
      "shortBio": "Building the layer between human intent and useful software: AI agents, local-first tools, and developer workflows. Sometimes shipping tomorrow by accident."
    }
  },
  "location": "Germany",
  "avatarUrl": "./assets/pengusto-avatar.png",
  "followers": 2,
  "following": 8,
  "languages": [
    {
      "name": "C#",
      "color": "#7355dd",
      "percentage": 44
    },
    {
      "name": "HTML",
      "color": "#e34c26",
      "percentage": 27
    },
    {
      "name": "JavaScript",
      "color": "#f1e05a",
      "percentage": 14
    },
    {
      "name": "TeX",
      "color": "#3D6117",
      "percentage": 8
    },
    {
      "name": "Python",
      "color": "#3572A5",
      "percentage": 3
    },
    {
      "name": "CSS",
      "color": "#663399",
      "percentage": 2
    },
    {
      "name": "TypeScript",
      "color": "#3178c6",
      "percentage": 1
    },
    {
      "name": "Kotlin",
      "color": "#A97BFF",
      "percentage": 0
    }
  ],
  "totalRepos": 15,
  "totalStars": 5,
  "websiteUrl": "kikaio.de",
  "pinnedRepos": [
    {
      "name": "penguin-patches",
      "description": "Focused Android app patches compatible with Morphe. Current catalogue: Fossify Calendar, Messages, File Manager, Contacts and Music Player. Pre-release.",
      "stars": 2,
      "forks": 0,
      "language": "Kotlin",
      "url": "https://github.com/pengusto/penguin-patches"
    },
    {
      "name": "let-him-grill",
      "description": "A Codex planning skill: resolve reversible decisions, stop at human gates, and resume the decision path.",
      "stars": 1,
      "forks": 0,
      "language": "Python",
      "url": "https://github.com/pengusto/let-him-grill"
    },
    {
      "name": "kaplum-studio",
      "description": "Learn JavaScript by drawing: a visual Turtle studio with editable examples, guided experiments, code stepping and offline project export.",
      "stars": 0,
      "forks": 0,
      "language": "JavaScript",
      "url": "https://github.com/pengusto/kaplum-studio"
    },
    {
      "name": "push-my-tabs",
      "description": "Layout-aware keyboard shortcuts and quick tab actions for Chrome and Firefox. Switch and move horizontal or vertical tabs.",
      "stars": 0,
      "forks": 0,
      "language": "JavaScript",
      "url": "https://github.com/pengusto/push-my-tabs"
    },
    {
      "name": "cookbook",
      "description": "Focused agent workflows for Codex and Claude Code. One shared source, Plain or Kitchen names. Experimental Beta.",
      "stars": 0,
      "forks": 0,
      "language": "HTML",
      "url": "https://github.com/pengusto/cookbook"
    },
    {
      "name": "you-got-this",
      "description": "Autonomous project-execution skill for Codex and compatible agent harnesses.",
      "stars": 0,
      "forks": 0,
      "language": "Python",
      "url": "https://github.com/pengusto/you-got-this"
    },
    {
      "name": "spark-hedge-physics-2-community",
      "description": "Independent Spark / Hedge Physics 2 community mirror: minimal Unity capsule demo, WASD controls, and attributed upstream source reference.",
      "stars": 1,
      "forks": 0,
      "language": "C#",
      "url": "https://github.com/pengusto/spark-hedge-physics-2-community"
    },
    {
      "name": "google-classroom-mcp",
      "description": "Local Google Classroom MCP for teachers: validated tools, scheduled drafts, file attachments and paginated course access.",
      "stars": 1,
      "forks": 0,
      "language": "TypeScript",
      "url": "https://github.com/pengusto/google-classroom-mcp"
    }
  ],
  "featuredRepos": [
    {
      "name": "penguin-patches",
      "description": "Focused Android app patches compatible with Morphe. Current catalogue: Fossify Calendar, Messages, File Manager, Contacts and Music Player. Pre-release.",
      "stars": 2,
      "forks": 0,
      "language": "Kotlin",
      "url": "https://github.com/pengusto/penguin-patches"
    },
    {
      "name": "let-him-grill",
      "description": "A Codex planning skill: resolve reversible decisions, stop at human gates, and resume the decision path.",
      "stars": 1,
      "forks": 0,
      "language": "Python",
      "url": "https://github.com/pengusto/let-him-grill"
    },
    {
      "name": "kaplum-studio",
      "description": "Learn JavaScript by drawing: a visual Turtle studio with editable examples, guided experiments, code stepping and offline project export.",
      "stars": 0,
      "forks": 0,
      "language": "JavaScript",
      "url": "https://github.com/pengusto/kaplum-studio"
    },
    {
      "name": "push-my-tabs",
      "description": "Layout-aware keyboard shortcuts and quick tab actions for Chrome and Firefox. Switch and move horizontal or vertical tabs.",
      "stars": 0,
      "forks": 0,
      "language": "JavaScript",
      "url": "https://github.com/pengusto/push-my-tabs"
    },
    {
      "name": "cookbook",
      "description": "Focused agent workflows for Codex and Claude Code. One shared source, Plain or Kitchen names. Experimental Beta.",
      "stars": 0,
      "forks": 0,
      "language": "HTML",
      "url": "https://github.com/pengusto/cookbook"
    },
    {
      "name": "you-got-this",
      "description": "Autonomous project-execution skill for Codex and compatible agent harnesses.",
      "stars": 0,
      "forks": 0,
      "language": "Python",
      "url": "https://github.com/pengusto/you-got-this"
    },
    {
      "name": "spark-hedge-physics-2-community",
      "description": "Independent Spark / Hedge Physics 2 community mirror: minimal Unity capsule demo, WASD controls, and attributed upstream source reference.",
      "stars": 1,
      "forks": 0,
      "language": "C#",
      "url": "https://github.com/pengusto/spark-hedge-physics-2-community"
    },
    {
      "name": "google-classroom-mcp",
      "description": "Local Google Classroom MCP for teachers: validated tools, scheduled drafts, file attachments and paginated course access.",
      "stars": 1,
      "forks": 0,
      "language": "TypeScript",
      "url": "https://github.com/pengusto/google-classroom-mcp"
    }
  ],
  "twitterUsername": null,
  "totalContributions": 2933,
  "contributionCalendar": {
    "weeks": [
      {
        "contributionDays": [
          {
            "date": "2025-10-19",
            "contributionCount": 0
          },
          {
            "date": "2025-10-20",
            "contributionCount": 0
          },
          {
            "date": "2025-10-21",
            "contributionCount": 0
          },
          {
            "date": "2025-10-22",
            "contributionCount": 0
          },
          {
            "date": "2025-10-23",
            "contributionCount": 0
          },
          {
            "date": "2025-10-24",
            "contributionCount": 0
          },
          {
            "date": "2025-10-25",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2025-10-26",
            "contributionCount": 0
          },
          {
            "date": "2025-10-27",
            "contributionCount": 0
          },
          {
            "date": "2025-10-28",
            "contributionCount": 0
          },
          {
            "date": "2025-10-29",
            "contributionCount": 0
          },
          {
            "date": "2025-10-30",
            "contributionCount": 0
          },
          {
            "date": "2025-10-31",
            "contributionCount": 0
          },
          {
            "date": "2025-11-01",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2025-11-02",
            "contributionCount": 0
          },
          {
            "date": "2025-11-03",
            "contributionCount": 0
          },
          {
            "date": "2025-11-04",
            "contributionCount": 0
          },
          {
            "date": "2025-11-05",
            "contributionCount": 0
          },
          {
            "date": "2025-11-06",
            "contributionCount": 0
          },
          {
            "date": "2025-11-07",
            "contributionCount": 0
          },
          {
            "date": "2025-11-08",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2025-11-09",
            "contributionCount": 0
          },
          {
            "date": "2025-11-10",
            "contributionCount": 0
          },
          {
            "date": "2025-11-11",
            "contributionCount": 0
          },
          {
            "date": "2025-11-12",
            "contributionCount": 0
          },
          {
            "date": "2025-11-13",
            "contributionCount": 0
          },
          {
            "date": "2025-11-14",
            "contributionCount": 0
          },
          {
            "date": "2025-11-15",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2025-11-16",
            "contributionCount": 0
          },
          {
            "date": "2025-11-17",
            "contributionCount": 0
          },
          {
            "date": "2025-11-18",
            "contributionCount": 0
          },
          {
            "date": "2025-11-19",
            "contributionCount": 0
          },
          {
            "date": "2025-11-20",
            "contributionCount": 0
          },
          {
            "date": "2025-11-21",
            "contributionCount": 0
          },
          {
            "date": "2025-11-22",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2025-11-23",
            "contributionCount": 0
          },
          {
            "date": "2025-11-24",
            "contributionCount": 0
          },
          {
            "date": "2025-11-25",
            "contributionCount": 0
          },
          {
            "date": "2025-11-26",
            "contributionCount": 0
          },
          {
            "date": "2025-11-27",
            "contributionCount": 0
          },
          {
            "date": "2025-11-28",
            "contributionCount": 0
          },
          {
            "date": "2025-11-29",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2025-11-30",
            "contributionCount": 0
          },
          {
            "date": "2025-12-01",
            "contributionCount": 0
          },
          {
            "date": "2025-12-02",
            "contributionCount": 0
          },
          {
            "date": "2025-12-03",
            "contributionCount": 0
          },
          {
            "date": "2025-12-04",
            "contributionCount": 0
          },
          {
            "date": "2025-12-05",
            "contributionCount": 0
          },
          {
            "date": "2025-12-06",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2025-12-07",
            "contributionCount": 0
          },
          {
            "date": "2025-12-08",
            "contributionCount": 0
          },
          {
            "date": "2025-12-09",
            "contributionCount": 0
          },
          {
            "date": "2025-12-10",
            "contributionCount": 0
          },
          {
            "date": "2025-12-11",
            "contributionCount": 0
          },
          {
            "date": "2025-12-12",
            "contributionCount": 0
          },
          {
            "date": "2025-12-13",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2025-12-14",
            "contributionCount": 0
          },
          {
            "date": "2025-12-15",
            "contributionCount": 0
          },
          {
            "date": "2025-12-16",
            "contributionCount": 0
          },
          {
            "date": "2025-12-17",
            "contributionCount": 0
          },
          {
            "date": "2025-12-18",
            "contributionCount": 0
          },
          {
            "date": "2025-12-19",
            "contributionCount": 0
          },
          {
            "date": "2025-12-20",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2025-12-21",
            "contributionCount": 0
          },
          {
            "date": "2025-12-22",
            "contributionCount": 0
          },
          {
            "date": "2025-12-23",
            "contributionCount": 1
          },
          {
            "date": "2025-12-24",
            "contributionCount": 0
          },
          {
            "date": "2025-12-25",
            "contributionCount": 0
          },
          {
            "date": "2025-12-26",
            "contributionCount": 0
          },
          {
            "date": "2025-12-27",
            "contributionCount": 3
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2025-12-28",
            "contributionCount": 6
          },
          {
            "date": "2025-12-29",
            "contributionCount": 0
          },
          {
            "date": "2025-12-30",
            "contributionCount": 0
          },
          {
            "date": "2025-12-31",
            "contributionCount": 0
          },
          {
            "date": "2026-01-01",
            "contributionCount": 0
          },
          {
            "date": "2026-01-02",
            "contributionCount": 0
          },
          {
            "date": "2026-01-03",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-01-04",
            "contributionCount": 0
          },
          {
            "date": "2026-01-05",
            "contributionCount": 0
          },
          {
            "date": "2026-01-06",
            "contributionCount": 0
          },
          {
            "date": "2026-01-07",
            "contributionCount": 3
          },
          {
            "date": "2026-01-08",
            "contributionCount": 0
          },
          {
            "date": "2026-01-09",
            "contributionCount": 0
          },
          {
            "date": "2026-01-10",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-01-11",
            "contributionCount": 0
          },
          {
            "date": "2026-01-12",
            "contributionCount": 0
          },
          {
            "date": "2026-01-13",
            "contributionCount": 0
          },
          {
            "date": "2026-01-14",
            "contributionCount": 0
          },
          {
            "date": "2026-01-15",
            "contributionCount": 1
          },
          {
            "date": "2026-01-16",
            "contributionCount": 0
          },
          {
            "date": "2026-01-17",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-01-18",
            "contributionCount": 1
          },
          {
            "date": "2026-01-19",
            "contributionCount": 4
          },
          {
            "date": "2026-01-20",
            "contributionCount": 0
          },
          {
            "date": "2026-01-21",
            "contributionCount": 0
          },
          {
            "date": "2026-01-22",
            "contributionCount": 1
          },
          {
            "date": "2026-01-23",
            "contributionCount": 0
          },
          {
            "date": "2026-01-24",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-01-25",
            "contributionCount": 5
          },
          {
            "date": "2026-01-26",
            "contributionCount": 22
          },
          {
            "date": "2026-01-27",
            "contributionCount": 1
          },
          {
            "date": "2026-01-28",
            "contributionCount": 0
          },
          {
            "date": "2026-01-29",
            "contributionCount": 0
          },
          {
            "date": "2026-01-30",
            "contributionCount": 0
          },
          {
            "date": "2026-01-31",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-02-01",
            "contributionCount": 0
          },
          {
            "date": "2026-02-02",
            "contributionCount": 0
          },
          {
            "date": "2026-02-03",
            "contributionCount": 14
          },
          {
            "date": "2026-02-04",
            "contributionCount": 1
          },
          {
            "date": "2026-02-05",
            "contributionCount": 0
          },
          {
            "date": "2026-02-06",
            "contributionCount": 0
          },
          {
            "date": "2026-02-07",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-02-08",
            "contributionCount": 0
          },
          {
            "date": "2026-02-09",
            "contributionCount": 0
          },
          {
            "date": "2026-02-10",
            "contributionCount": 0
          },
          {
            "date": "2026-02-11",
            "contributionCount": 2
          },
          {
            "date": "2026-02-12",
            "contributionCount": 0
          },
          {
            "date": "2026-02-13",
            "contributionCount": 1
          },
          {
            "date": "2026-02-14",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-02-15",
            "contributionCount": 1
          },
          {
            "date": "2026-02-16",
            "contributionCount": 14
          },
          {
            "date": "2026-02-17",
            "contributionCount": 3
          },
          {
            "date": "2026-02-18",
            "contributionCount": 29
          },
          {
            "date": "2026-02-19",
            "contributionCount": 1
          },
          {
            "date": "2026-02-20",
            "contributionCount": 5
          },
          {
            "date": "2026-02-21",
            "contributionCount": 17
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-02-22",
            "contributionCount": 1
          },
          {
            "date": "2026-02-23",
            "contributionCount": 8
          },
          {
            "date": "2026-02-24",
            "contributionCount": 0
          },
          {
            "date": "2026-02-25",
            "contributionCount": 1
          },
          {
            "date": "2026-02-26",
            "contributionCount": 0
          },
          {
            "date": "2026-02-27",
            "contributionCount": 0
          },
          {
            "date": "2026-02-28",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-03-01",
            "contributionCount": 0
          },
          {
            "date": "2026-03-02",
            "contributionCount": 1
          },
          {
            "date": "2026-03-03",
            "contributionCount": 1
          },
          {
            "date": "2026-03-04",
            "contributionCount": 0
          },
          {
            "date": "2026-03-05",
            "contributionCount": 0
          },
          {
            "date": "2026-03-06",
            "contributionCount": 0
          },
          {
            "date": "2026-03-07",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-03-08",
            "contributionCount": 0
          },
          {
            "date": "2026-03-09",
            "contributionCount": 0
          },
          {
            "date": "2026-03-10",
            "contributionCount": 0
          },
          {
            "date": "2026-03-11",
            "contributionCount": 1
          },
          {
            "date": "2026-03-12",
            "contributionCount": 0
          },
          {
            "date": "2026-03-13",
            "contributionCount": 1
          },
          {
            "date": "2026-03-14",
            "contributionCount": 1
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-03-15",
            "contributionCount": 1
          },
          {
            "date": "2026-03-16",
            "contributionCount": 2
          },
          {
            "date": "2026-03-17",
            "contributionCount": 0
          },
          {
            "date": "2026-03-18",
            "contributionCount": 4
          },
          {
            "date": "2026-03-19",
            "contributionCount": 2
          },
          {
            "date": "2026-03-20",
            "contributionCount": 1
          },
          {
            "date": "2026-03-21",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-03-22",
            "contributionCount": 0
          },
          {
            "date": "2026-03-23",
            "contributionCount": 1
          },
          {
            "date": "2026-03-24",
            "contributionCount": 6
          },
          {
            "date": "2026-03-25",
            "contributionCount": 0
          },
          {
            "date": "2026-03-26",
            "contributionCount": 0
          },
          {
            "date": "2026-03-27",
            "contributionCount": 4
          },
          {
            "date": "2026-03-28",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-03-29",
            "contributionCount": 0
          },
          {
            "date": "2026-03-30",
            "contributionCount": 0
          },
          {
            "date": "2026-03-31",
            "contributionCount": 17
          },
          {
            "date": "2026-04-01",
            "contributionCount": 35
          },
          {
            "date": "2026-04-02",
            "contributionCount": 0
          },
          {
            "date": "2026-04-03",
            "contributionCount": 0
          },
          {
            "date": "2026-04-04",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-04-05",
            "contributionCount": 0
          },
          {
            "date": "2026-04-06",
            "contributionCount": 0
          },
          {
            "date": "2026-04-07",
            "contributionCount": 2
          },
          {
            "date": "2026-04-08",
            "contributionCount": 2
          },
          {
            "date": "2026-04-09",
            "contributionCount": 0
          },
          {
            "date": "2026-04-10",
            "contributionCount": 1
          },
          {
            "date": "2026-04-11",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-04-12",
            "contributionCount": 0
          },
          {
            "date": "2026-04-13",
            "contributionCount": 3
          },
          {
            "date": "2026-04-14",
            "contributionCount": 0
          },
          {
            "date": "2026-04-15",
            "contributionCount": 1
          },
          {
            "date": "2026-04-16",
            "contributionCount": 1
          },
          {
            "date": "2026-04-17",
            "contributionCount": 9
          },
          {
            "date": "2026-04-18",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-04-19",
            "contributionCount": 0
          },
          {
            "date": "2026-04-20",
            "contributionCount": 0
          },
          {
            "date": "2026-04-21",
            "contributionCount": 11
          },
          {
            "date": "2026-04-22",
            "contributionCount": 2
          },
          {
            "date": "2026-04-23",
            "contributionCount": 0
          },
          {
            "date": "2026-04-24",
            "contributionCount": 63
          },
          {
            "date": "2026-04-25",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-04-26",
            "contributionCount": 1
          },
          {
            "date": "2026-04-27",
            "contributionCount": 15
          },
          {
            "date": "2026-04-28",
            "contributionCount": 9
          },
          {
            "date": "2026-04-29",
            "contributionCount": 0
          },
          {
            "date": "2026-04-30",
            "contributionCount": 0
          },
          {
            "date": "2026-05-01",
            "contributionCount": 0
          },
          {
            "date": "2026-05-02",
            "contributionCount": 4
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-05-03",
            "contributionCount": 0
          },
          {
            "date": "2026-05-04",
            "contributionCount": 0
          },
          {
            "date": "2026-05-05",
            "contributionCount": 0
          },
          {
            "date": "2026-05-06",
            "contributionCount": 1
          },
          {
            "date": "2026-05-07",
            "contributionCount": 0
          },
          {
            "date": "2026-05-08",
            "contributionCount": 0
          },
          {
            "date": "2026-05-09",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-05-10",
            "contributionCount": 0
          },
          {
            "date": "2026-05-11",
            "contributionCount": 0
          },
          {
            "date": "2026-05-12",
            "contributionCount": 8
          },
          {
            "date": "2026-05-13",
            "contributionCount": 3
          },
          {
            "date": "2026-05-14",
            "contributionCount": 2
          },
          {
            "date": "2026-05-15",
            "contributionCount": 17
          },
          {
            "date": "2026-05-16",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-05-17",
            "contributionCount": 0
          },
          {
            "date": "2026-05-18",
            "contributionCount": 0
          },
          {
            "date": "2026-05-19",
            "contributionCount": 4
          },
          {
            "date": "2026-05-20",
            "contributionCount": 6
          },
          {
            "date": "2026-05-21",
            "contributionCount": 0
          },
          {
            "date": "2026-05-22",
            "contributionCount": 6
          },
          {
            "date": "2026-05-23",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-05-24",
            "contributionCount": 0
          },
          {
            "date": "2026-05-25",
            "contributionCount": 0
          },
          {
            "date": "2026-05-26",
            "contributionCount": 1
          },
          {
            "date": "2026-05-27",
            "contributionCount": 8
          },
          {
            "date": "2026-05-28",
            "contributionCount": 17
          },
          {
            "date": "2026-05-29",
            "contributionCount": 14
          },
          {
            "date": "2026-05-30",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-05-31",
            "contributionCount": 0
          },
          {
            "date": "2026-06-01",
            "contributionCount": 0
          },
          {
            "date": "2026-06-02",
            "contributionCount": 1
          },
          {
            "date": "2026-06-03",
            "contributionCount": 0
          },
          {
            "date": "2026-06-04",
            "contributionCount": 1
          },
          {
            "date": "2026-06-05",
            "contributionCount": 0
          },
          {
            "date": "2026-06-06",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-06-07",
            "contributionCount": 0
          },
          {
            "date": "2026-06-08",
            "contributionCount": 0
          },
          {
            "date": "2026-06-09",
            "contributionCount": 0
          },
          {
            "date": "2026-06-10",
            "contributionCount": 0
          },
          {
            "date": "2026-06-11",
            "contributionCount": 0
          },
          {
            "date": "2026-06-12",
            "contributionCount": 0
          },
          {
            "date": "2026-06-13",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-06-14",
            "contributionCount": 0
          },
          {
            "date": "2026-06-15",
            "contributionCount": 0
          },
          {
            "date": "2026-06-16",
            "contributionCount": 1
          },
          {
            "date": "2026-06-17",
            "contributionCount": 0
          },
          {
            "date": "2026-06-18",
            "contributionCount": 0
          },
          {
            "date": "2026-06-19",
            "contributionCount": 0
          },
          {
            "date": "2026-06-20",
            "contributionCount": 3
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-06-21",
            "contributionCount": 1
          },
          {
            "date": "2026-06-22",
            "contributionCount": 1
          },
          {
            "date": "2026-06-23",
            "contributionCount": 0
          },
          {
            "date": "2026-06-24",
            "contributionCount": 0
          },
          {
            "date": "2026-06-25",
            "contributionCount": 0
          },
          {
            "date": "2026-06-26",
            "contributionCount": 0
          },
          {
            "date": "2026-06-27",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-06-28",
            "contributionCount": 0
          },
          {
            "date": "2026-06-29",
            "contributionCount": 0
          },
          {
            "date": "2026-06-30",
            "contributionCount": 8
          },
          {
            "date": "2026-07-01",
            "contributionCount": 2
          },
          {
            "date": "2026-07-02",
            "contributionCount": 0
          },
          {
            "date": "2026-07-03",
            "contributionCount": 1
          },
          {
            "date": "2026-07-04",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-07-05",
            "contributionCount": 0
          },
          {
            "date": "2026-07-06",
            "contributionCount": 0
          },
          {
            "date": "2026-07-07",
            "contributionCount": 0
          },
          {
            "date": "2026-07-08",
            "contributionCount": 3
          },
          {
            "date": "2026-07-09",
            "contributionCount": 0
          },
          {
            "date": "2026-07-10",
            "contributionCount": 1
          },
          {
            "date": "2026-07-11",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-07-12",
            "contributionCount": 0
          },
          {
            "date": "2026-07-13",
            "contributionCount": 11
          },
          {
            "date": "2026-07-14",
            "contributionCount": 6
          },
          {
            "date": "2026-07-15",
            "contributionCount": 2
          },
          {
            "date": "2026-07-16",
            "contributionCount": 5
          },
          {
            "date": "2026-07-17",
            "contributionCount": 27
          },
          {
            "date": "2026-07-18",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-07-19",
            "contributionCount": 0
          },
          {
            "date": "2026-07-20",
            "contributionCount": 2
          },
          {
            "date": "2026-07-21",
            "contributionCount": 17
          },
          {
            "date": "2026-07-22",
            "contributionCount": 13
          },
          {
            "date": "2026-07-23",
            "contributionCount": 14
          },
          {
            "date": "2026-07-24",
            "contributionCount": 14
          },
          {
            "date": "2026-07-25",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-07-26",
            "contributionCount": 32
          },
          {
            "date": "2026-07-27",
            "contributionCount": 8
          },
          {
            "date": "2026-07-28",
            "contributionCount": 2
          },
          {
            "date": "2026-07-29",
            "contributionCount": 6
          },
          {
            "date": "2026-07-30",
            "contributionCount": 30
          },
          {
            "date": "2026-07-31",
            "contributionCount": 45
          },
          {
            "date": "2026-08-01",
            "contributionCount": 24
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-08-02",
            "contributionCount": 2
          },
          {
            "date": "2026-08-03",
            "contributionCount": 63
          },
          {
            "date": "2026-08-04",
            "contributionCount": 21
          },
          {
            "date": "2026-08-05",
            "contributionCount": 166
          },
          {
            "date": "2026-08-06",
            "contributionCount": 0
          },
          {
            "date": "2026-08-07",
            "contributionCount": 27
          },
          {
            "date": "2026-08-08",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-08-09",
            "contributionCount": 0
          },
          {
            "date": "2026-08-10",
            "contributionCount": 0
          },
          {
            "date": "2026-08-11",
            "contributionCount": 58
          },
          {
            "date": "2026-08-12",
            "contributionCount": 22
          },
          {
            "date": "2026-08-13",
            "contributionCount": 15
          },
          {
            "date": "2026-08-14",
            "contributionCount": 221
          },
          {
            "date": "2026-08-15",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-08-16",
            "contributionCount": 0
          },
          {
            "date": "2026-08-17",
            "contributionCount": 0
          },
          {
            "date": "2026-08-18",
            "contributionCount": 50
          },
          {
            "date": "2026-08-19",
            "contributionCount": 86
          },
          {
            "date": "2026-08-20",
            "contributionCount": 3
          },
          {
            "date": "2026-08-21",
            "contributionCount": 124
          },
          {
            "date": "2026-08-22",
            "contributionCount": 16
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-08-23",
            "contributionCount": 50
          },
          {
            "date": "2026-08-24",
            "contributionCount": 70
          },
          {
            "date": "2026-08-25",
            "contributionCount": 55
          },
          {
            "date": "2026-08-26",
            "contributionCount": 11
          },
          {
            "date": "2026-08-27",
            "contributionCount": 49
          },
          {
            "date": "2026-08-28",
            "contributionCount": 72
          },
          {
            "date": "2026-08-29",
            "contributionCount": 38
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-08-30",
            "contributionCount": 0
          },
          {
            "date": "2026-08-31",
            "contributionCount": 0
          },
          {
            "date": "2026-09-01",
            "contributionCount": 14
          },
          {
            "date": "2026-09-02",
            "contributionCount": 15
          },
          {
            "date": "2026-09-03",
            "contributionCount": 2
          },
          {
            "date": "2026-09-04",
            "contributionCount": 0
          },
          {
            "date": "2026-09-05",
            "contributionCount": 0
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-09-06",
            "contributionCount": 1
          },
          {
            "date": "2026-09-07",
            "contributionCount": 4
          },
          {
            "date": "2026-09-08",
            "contributionCount": 56
          },
          {
            "date": "2026-09-09",
            "contributionCount": 46
          },
          {
            "date": "2026-09-10",
            "contributionCount": 19
          },
          {
            "date": "2026-09-11",
            "contributionCount": 10
          },
          {
            "date": "2026-09-12",
            "contributionCount": 2
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-09-13",
            "contributionCount": 0
          },
          {
            "date": "2026-09-14",
            "contributionCount": 0
          },
          {
            "date": "2026-09-15",
            "contributionCount": 2
          },
          {
            "date": "2026-09-16",
            "contributionCount": 0
          },
          {
            "date": "2026-09-17",
            "contributionCount": 13
          },
          {
            "date": "2026-09-18",
            "contributionCount": 5
          },
          {
            "date": "2026-09-19",
            "contributionCount": 19
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-09-20",
            "contributionCount": 35
          },
          {
            "date": "2026-09-21",
            "contributionCount": 87
          },
          {
            "date": "2026-09-22",
            "contributionCount": 6
          },
          {
            "date": "2026-09-23",
            "contributionCount": 3
          },
          {
            "date": "2026-09-24",
            "contributionCount": 6
          },
          {
            "date": "2026-09-25",
            "contributionCount": 5
          },
          {
            "date": "2026-09-26",
            "contributionCount": 12
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-09-27",
            "contributionCount": 6
          },
          {
            "date": "2026-09-28",
            "contributionCount": 47
          },
          {
            "date": "2026-09-29",
            "contributionCount": 20
          },
          {
            "date": "2026-09-30",
            "contributionCount": 0
          },
          {
            "date": "2026-10-01",
            "contributionCount": 4
          },
          {
            "date": "2026-10-02",
            "contributionCount": 0
          },
          {
            "date": "2026-10-03",
            "contributionCount": 2
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-10-04",
            "contributionCount": 2
          },
          {
            "date": "2026-10-05",
            "contributionCount": 6
          },
          {
            "date": "2026-10-06",
            "contributionCount": 18
          },
          {
            "date": "2026-10-07",
            "contributionCount": 25
          },
          {
            "date": "2026-10-08",
            "contributionCount": 39
          },
          {
            "date": "2026-10-09",
            "contributionCount": 31
          },
          {
            "date": "2026-10-10",
            "contributionCount": 19
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-10-11",
            "contributionCount": 33
          },
          {
            "date": "2026-10-12",
            "contributionCount": 135
          },
          {
            "date": "2026-10-13",
            "contributionCount": 45
          },
          {
            "date": "2026-10-14",
            "contributionCount": 20
          },
          {
            "date": "2026-10-15",
            "contributionCount": 7
          },
          {
            "date": "2026-10-16",
            "contributionCount": 7
          },
          {
            "date": "2026-10-17",
            "contributionCount": 11
          }
        ]
      },
      {
        "contributionDays": [
          {
            "date": "2026-10-18",
            "contributionCount": 2
          },
          {
            "date": "2026-10-19",
            "contributionCount": 4
          },
          {
            "date": "2026-10-20",
            "contributionCount": 6
          },
          {
            "date": "2026-10-21",
            "contributionCount": 18
          },
          {
            "date": "2026-10-22",
            "contributionCount": 31
          },
          {
            "date": "2026-10-23",
            "contributionCount": 98
          }
        ]
      }
    ]
  },
  "username": "pengusto"
}